<template>
  <span>
    <v-overlay
      :absolute="true"
      :value="loading"
    >
        <v-progress-circular
        :size="50"
        color="success"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>
    <v-card
      class="mx-auto"
      min-height="350px"
      outlined
    >
      <v-card-title>
        <!-- Pagamentos {{processo_id}} -->
        <v-container class="fill-width">
          <v-row>
            <v-col cols="12">
              <v-card class="mx-0 px-0">
                <v-card-title class="success white--text">
                  <span class="text-h5">Pagamento Indenização</span>
                </v-card-title>
                <v-card-text class="mx-0 px-1">
                  <v-form
                    ref="formPgto"
                    class="mx-auto pt-0 mt-0 fill-width"
                  >
                    <v-container fluid class="mx-0">
                      <v-row>
                        <v-col cols="12" md="6">               
                          <v-text-field
                            v-mask="'##/##/####'"
                            v-model="$v.formPgtoProcesso.dt_pgtoideniz.$model"
                            :errorMessages="validacaoForm($v.formPgtoProcesso.dt_pgtoideniz, '')"
                            label="Data Pgto Indeniz"
                            autocomplete="disabled"
                            placeholder="00/00/0000"
                            :disabled="!permitirAlteracaoPagamento()" 
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <VuetifyMoney
                            v-model="$v.formPgtoProcesso.vl_pgtoindeniz.$model"
                            :errorMessages="validacaoForm($v.formPgtoProcesso.vl_pgtoindeniz, '')"
                            v-bind:label="'Valor Indenização'"
                            placeholder="00,00"
                            autocomplete="nope"
                            :disabled="!permitirAlteracaoPagamento()" 
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>        
          </v-row>

          <v-row>
            <v-col cols="12">
              <parcela-pagamento ref="formParcelaPagamento" :processo_id="processo_id" :parcelas="parcelas" :status="status" :data_indenizacao="this.formPgtoProcesso.dt_pgtoideniz" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
  </span>
</template>

<script>

import ParcelaPagamento from "./ParcelasView.vue"
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import validacaoForm from '@/mixins/validacaoForm'
import utils from "@/mixins/utils";
import VuetifyMoney from "@/components/Inputs/VuetifyMoney.vue";
import validaProcesso from '@/utils/validaProcesso'
import moment  from 'moment';

const dateValid = function(value) {
  if (!helpers.req(value)) return true
  return moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"]).isValid()
}

export default {
  name: 'Pagamentos_Processo',
  props: {
    processo_id: {
      type: Number,
      required: true
    },
    status: {
      required: true
    },
    data_processo: {
      required: false
    }
  },
  components: {VuetifyMoney, ParcelaPagamento},
  mixins:[validacaoForm, utils],
  data() {
    return {
      menuDataIndenizacao: false,
      loading: false,
      formPgtoProcesso: {
        dt_pgtoideniz: "",
        vl_pgtoindeniz: "",
      },
      parcelas: []
    }
  },
  validations: {
    formPgtoProcesso: {
      dt_pgtoideniz: { 
        required: requiredIf(function() {
          if (this.existeParcelaAtiva()) return true
          if (this.obrigaPreencherPgtoIndenizacao()) return true
          return false
        }),
        dateValid, 
        errors: [] 
      }
      ,
      vl_pgtoindeniz: { 
        required: requiredIf(function() {
          if (this.existeParcelaAtiva()) return true
          if (this.obrigaPreencherPgtoIndenizacao()) return true
          return false
        }),
        errors: [] 
      },
    }
  },
  created() {
    this.buscarPagamento()
  },
  methods: {
    ...mapActions({
      actBuscaPagamentosProcesso: "pagamentoProcesso/GET_PGTOPROCESSO",
      actStorePgtoProcesso: "pagamentoProcesso/STORE_PGTOPROCESSO",
      actSelectPagamentosProcesso: "pagamentoProcesso/PGTOPROCESSO_SELECTED",
    }),
    ...mapMutations({
      commitErro: 'processo/SET_ERROS',
      resetErros: 'processo/ERASE_ERROS',
    }),

    permitirAlteracaoPagamento(){
      return validaProcesso.permissaoAlterarValorPgto(this.status)
    },

    async buscarPagamento() {
      this.loading = true
      try {
        await this.actBuscaPagamentosProcesso(this.processo_id)
      } catch(e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },

    sincronizarPagamentoProcesso(payload) {
      if (payload.dt_pgtoideniz) payload.dt_pgtoideniz = this.converteDataParaView(payload.dt_pgtoideniz)
      this.formPgtoProcesso = Object.assign(
        {},
        payload
      )
      this.parcelas = this.formPgtoProcesso.parcelas ? this.formPgtoProcesso.parcelas : []
    },

    async validaForm () {
      if (this.$refs.formParcelaPagamento) {
        if (!await this.$refs.formParcelaPagamento.validaForm()) return false
        try {
          let objParcelas = await this.$refs.formParcelaPagamento.gravar()
          this.formPgtoProcesso.parcelas = JSON.parse(JSON.stringify(objParcelas))          
        } catch (e) {
          console.log(e)
          return false
        }
      }
      this.$v.formPgtoProcesso.$touch();
      if (!this.$v.formPgtoProcesso.$invalid) {
        return true
      } else if (this.$v.formPgtoProcesso.$anyError) {
        return false
      }
    },
    async gravar() {

      if (!this.formPgtoProcesso.dt_pgtoideniz && !this.formPgtoProcesso.vl_pgtoindeniz) return true

      var pgto = JSON.parse(JSON.stringify(this.formPgtoProcesso))
      if (this.$refs.formParcelaPagamento) {
        try {
          let objParcelas = await this.$refs.formParcelaPagamento.gravar()
          pgto.parcelas = JSON.parse(JSON.stringify(objParcelas))
        } catch (e) {
          //console.log(e)
          return false
        }
      }

      if (!pgto.dt_lancamento) pgto.dt_lancamento = this.$moment().format('YYYY-MM-DD')
      if (!pgto.processo_id) pgto.processo_id = this.processo_id
      pgto.dt_pgtoideniz = this.converteDataParaApi(pgto.dt_pgtoideniz)
      pgto.st_procTela = this.status

      try {
        await this.actStorePgtoProcesso(pgto)
      } catch (e) {
        return false
      }

      return true

    },
    obrigaPreencherPgtoIndenizacao() {
      return validaProcesso.exigirDataPagamentoIndenizacao(this.status)
    },
    existeParcelaAtiva() {
      if (!this.formPgtoProcesso.parcelas || !this.formPgtoProcesso.parcelas.length) return false
      let notDeleted = this.formPgtoProcesso.parcelas.filter(item => !item.isExcluido)
      return notDeleted.length ? true : false
    }

  },
  watch: {
    async pagamentoProcessoSelecionado(novo, antigo) {
      await this.sincronizarPagamentoProcesso(novo)
    },
  },
  computed: {
    ...mapState('pagamentoProcesso', [
      "pagamentoProcessoSelecionado"
    ]),
    dataPagamentoIndenFormatada: {
      get: function() {
        if (!this.formPgtoProcesso.dt_pgtoideniz) return this.formPgtoProcesso.dt_pgtoideniz
        return this.$moment(this.formPgtoProcesso.dt_pgtoideniz, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      set: function(newVal){
        this.formPgtoProcesso.dt_pgtoideniz = newVal
      }
    },
  },
  beforeDestroy() {
    this.resetErros()
  }


}
</script>



// WEBPACK FOOTER //
// src/views/Pagamentos/PagamentosView.vue